export type localOrCloud = 'local' | 'cloud';

export type ProjectConfig = {
    [key: string]: {
        firebaseConfig: { [key: string]: string };
        cloudRunURLs: { [key: string]: string };
        algoliaConfig: {
            local: { [key: string]: string };
            cloud: { [key: string]: string };
        };
        usersnapSpaceId: string;
        googleMapsApiKey: string;
        posthogConfig: {
            posthogApiKey: string;
            posthogHost: string;
            posthogDebug: string;
            disableTelemetry: string;
        };
        mcpOAuthEnabled: boolean;
    };
}

import configData from './config.json';
import { buildInfo } from './buildInfo';

export const projectConfigs: ProjectConfig = configData;

export const deploymentEnvironment: localOrCloud = import.meta.env?.REACT_APP_DEPLOYMENT_TYPE as localOrCloud || 'cloud';
export const firebaseProjectAlias = import.meta.env?.REACT_APP_FIREBASE_PROJECT_ALIAS || 'dev';

if (!projectConfigs[firebaseProjectAlias]) {
    throw new Error(`Invalid Firebase project alias: ${firebaseProjectAlias}. Available: ${Object.keys(projectConfigs).join(', ')}`);
}

export const config = projectConfigs[firebaseProjectAlias];
export const firebaseConfig = config.firebaseConfig;
export const cloudRunURLs = config.cloudRunURLs;
export const algoliaConfig = config.algoliaConfig[deploymentEnvironment];
export const usersnapSpaceId = config.usersnapSpaceId;
export const googleMapsApiKey = deploymentEnvironment === 'local' 
    ? (import.meta.env.VITE_GOOGLE_MAPS_API_KEY_LOCAL || '')
    : config.googleMapsApiKey;
export const mcpOAuthEnabled = config.mcpOAuthEnabled && deploymentEnvironment !== 'local';
export const environmentType = import.meta.env.PROD ? 'production' : 'development';

// Emulator configuration
export const emulatorPorts = {
    firestore: parseInt(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT || '8080'),
    auth: parseInt(import.meta.env.VITE_AUTH_EMULATOR_PORT || '9001'),
    functions: parseInt(import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT || '5001'),
    storage: parseInt(import.meta.env.VITE_STORAGE_EMULATOR_PORT || '9401'),
    cloudRun: parseInt(import.meta.env.VITE_CLOUD_RUN_EMULATOR_PORT || '8081'),
};

/** DEV FLAG 
 * Use to hide from prod test or pre-prod options
*/
export const devFlag = firebaseProjectAlias === 'dev' || environmentType === 'development';

const versionLine = buildInfo.commit === null
    ? buildInfo.version
    : `${buildInfo.version} (${buildInfo.commit}${buildInfo.dirty ? ', dirty' : ''})`;

console.log(`firebase project alias: ${firebaseProjectAlias}
firebase project id: ${firebaseConfig['projectId']}
environmentType: ${environmentType}
deploymentEnvironment: ${deploymentEnvironment}
version: ${versionLine}`
);
